import { createReceiptApi } from "api/receipt";

export async function setReceiptLog(userData, receiptData) {
  const normalized = Object.fromEntries(
    Object.entries(receiptData || {}).map(([k, v]) => [k, v === undefined ? null : v]),
  );
  try {
    await createReceiptApi({
      userId: userData?.docId || userData?.id || "",
      ...normalized,
    });
  } catch (e) {
    console.error("setReceiptLog failed", e);
  }
}
